import { buildScopedI18n } from '../../utils/buildScopedI18n';
import esCL from './sacLocales/es-CL.json';
import enUS from './sacLocales/en-US.json';
import ptBR from './sacLocales/pt-BR.json';

export const sacI18n = buildScopedI18n({
  esCL,
  enUS,
  ptBR,
});
